import React, { PropTypes } from 'react';
import Money from 'common/components/money';
import moment from 'moment';

const HISTORY_STATUS_CLASSES = {
  paid: 'text-success',
  rejected: 'text-danger',
  cancelled: 'text-danger',
  refunded: 'text-warning',
}

/**
 * Payment row.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
const PaymentRow = ({ item, type, onExpand, expanded, className }) => {
  const date = type == 'history'? item.date_paid : item.date;

  return (
    <tr className={className}>
      <td><Money value={item.amount}/></td>
      <td>
        { date? moment(date).format('MMM D, YYYY') : <a onClick={onExpand}>See Details</a> }
      </td>
      <td className="hide-for-small-only">{ item.system }</td>
      <td onClick={onExpand}>
        {item.awards.length} <i className={"fa fa-angle-" + (expanded? "down":"up")} />
      </td>
      <td>
        {type === 'history'?
        <i className={"fa fa-circle " + HISTORY_STATUS_CLASSES[item.status]}/> :
        item.status}
      </td>
    </tr>);
};

/**
 * PropTypes.
 *
 * @property {object} item - payment item
 * @property {string} type - item type ('requested' or 'history')
 * @property {func} onExpand - called when awards are expanded
 * @property {bool} expanded - whether awards are expanded
 * @property {string} className - CSS classes
 */
PaymentRow.propTypes = {
  item: PropTypes.object,
  type: PropTypes.string,
  onExpand: PropTypes.func,
  expanded: PropTypes.bool,
  className: PropTypes.string
};

export default PaymentRow;



// WEBPACK FOOTER //
// ./account/components/payout/payment_row.jsx